const STANDS_PENDING = 'stands_pending';
const STANDS_FAILED = 'stands_failed';
const STANDS_DOWNLOADED = 'stands_downloaded';
const STANDS_RESET = 'stands_reset';
const STAND_SENDING = 'stand_sending';
const STAND_DOWNLOADED = 'stand_downloaded';

export {
  STANDS_PENDING,
  STANDS_FAILED,
  STANDS_DOWNLOADED,
  STANDS_RESET,
  STAND_SENDING,
  STAND_DOWNLOADED,
};



// WEBPACK FOOTER //
// ./src/store/stands/types.js